import { render, staticRenderFns } from "./hardwareUpgradeList.vue?vue&type=template&id=31a6261a&scoped=true"
import script from "./hardwareUpgradeList.vue?vue&type=script&lang=ts"
export * from "./hardwareUpgradeList.vue?vue&type=script&lang=ts"
import style0 from "./hardwareUpgradeList.vue?vue&type=style&index=0&id=31a6261a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6261a",
  null
  
)

export default component.exports